import { Card, PageHeader, Input, Btn } from "../../components/shared/UIComponents";

export default function SASettings() {
  return (
    <Card>
      <PageHeader title="Super Admin Settings" />
      <div style={{ padding: 28, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <Input label="Super Admin Name" defaultValue="Super Admin" />
        <Input label="Username" defaultValue="superadmin" />
        <Input label="Email" defaultValue="superadmin@apitservices.com" />
        <Input label="New Password" type="password" placeholder="Enter new password" />
        <div style={{ gridColumn: "span 2" }}><Btn>Update Settings</Btn></div>
      </div>
    </Card>
  );
}
